const ResetIcon = ({ width, height, color, className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            enable-background="new 0 0 24 24"
            viewBox="0 0 24 24"
            className={
                "icon" + (className !== undefined ? " " + className : "")
            }
            width={width || 48}
            height={height || 48}
            fill={color || "#FFFFFF"}
        >
            <g>
                <path d="M0,0h24v24H0V0z" fill="none" />
            </g>
            <g>
                <g>
                    <path d="M6,13c0-1.65,0.67-3.15,1.76-4.24L6.34,7.34C4.9,8.79,4,10.79,4,13c0,4.08,3.05,7.44,7,7.93v-2.02 C8.17,18.43,6,15.97,6,13z M20,13c0-4.42-3.58-8-8-8c-0.06,0-0.12,0.01-0.18,0.01l1.09-1.09L11.5,2.5L8,6l3.5,3.5l1.41-1.41 l-1.08-1.08C11.89,7.01,11.95,7,12,7c3.31,0,6,2.69,6,6c0,2.97-2.17,5.43-5,5.91v2.02C16.95,20.44,20,17.08,20,13z" />
                </g>
            </g>
        </svg>
    );
};

const PauseIcon = ({ width, height, color, className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={
                "icon" + (className !== undefined ? " " + className : "")
            }
            width={width || 48}
            height={height || 48}
            fill={color || "#FFFFFF"}
        >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
        </svg>
    );
};

const ResumeIcon = ({ width, height, color, className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={
                "icon" + (className !== undefined ? " " + className : "")
            }
            viewBox="0 0 24 24"
            width={width || 48}
            height={height || 48}
            fill={color || "#FFFFFF"}
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M8 5v14l11-7z" />
        </svg>
    );
};

const SkipIcon = ({ width, height, color, className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={
                "icon" + (className !== undefined ? " " + className : "")
            }
            viewBox="0 0 24 24"
            width={width || 48}
            height={height || 48}
            fill={color || "#FFFFFF"}
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" />
        </svg>
    );
};

const DoneIcon = ({ width, height, color, className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={
                "icon" + (className !== undefined ? " " + className : "")
            }
            viewBox="0 0 24 24"
            width={width || 48}
            height={height || 48}
            fill={color || "#FFFFFF"}
        >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
        </svg>
    );
};

export { ResetIcon, PauseIcon, ResumeIcon, SkipIcon, DoneIcon };
